import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: {
        uid: null,
        name: null,
        email: null
        //photo: null
      },
      profile: {
        name: null,
        email: null
      }
    }
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        const auth = firebase.auth().currentUser;
        commit("SET_USER", {
          uid: auth.uid,
          name: user.name,
          email: user.email
          //logo: user.photoURL
        });
      } else {
        commit("SET_USER", null);
      }
    },
    getProfile({ commit }, user) {
      // Get profile
      if (user) {
        const auth = firebase.auth().currentUser;

        var firestore = firebase.firestore();
        var userRef = firestore.collection("users").doc(String(auth.uid));
        userRef.onSnapshot(function(doc) {
          //console.log("Current data: ", doc.data());
          var profile = doc.data();
          commit("SET_PROFILE", profile);
        });
      } else {
        commit("SET_PROFILE", null);
      }
    }
  },
  plugins: [createPersistedState()],
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    SET_PROFILE(state, profile) {
      state.user.profile = profile;
    }
  }
});
